import React from 'react';

const ItemWinner = (props) => {
    return (
        <div className="item-winner">
            <img src={props.image} />
            <div className="details">
                <h4>{props.title}</h4>
                <span>{props.description}</span>
            </div>
            <div className="grade">
                <span>{props.grade}</span>
                <img src="/icons/Group 11800.svg" />
            </div>
        </div>
    );
}

export default ItemWinner;